import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  IconButton,
  MenuItem,
  FormControl,
  Select,
  Typography,
  Switch,
  TextField,
  Tooltip,
  Button,
  Slider,
  ThemeProvider, createTheme
} from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TodayIcon from '@mui/icons-material/Today';

const lowerLayerButtonTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#4b4b4bff",
          color: "#ffffff",
          borderRadius: "5px",
          //marginRight: "8px",
          paddingTop: "2px",
          paddingBottom: "2px",
          //paddingLeft: "8px",
          //paddingRight: "8px",
          fontSize: "13.5px",
          textTransform: "none",
          height: '32px',
          width: '90px',
          "&:hover": {
            backgroundColor: "#2d2d2dff"
          }
        }
      }
    }
  }
});

const iconMap = {
  add: AddIcon,
  edit: EditIcon,
  delete: DeleteIcon,
};

const validTabs = ["Inventory View", "Where Used"];

const TabLayout = ({
  tabs = [],
  currentTab,
  onTabChange,
  startAdornment,
  currentTabToolbarConfig,
}) => {
  // Local state for dropdown selections
  const [dropdownValues, setDropdownValues] = useState({});
  const [showSliderPanel, setShowSliderPanel] = useState(false);
  const handleDropdownChange = (index, value) => {
    setDropdownValues(prev => ({
      ...prev,
      [index]: value
    }));
  };
  if (!Array.isArray(tabs) || tabs.length === 0) return null;

  const currentTabData = tabs[currentTab] || {};
  const { buttons, icons, search, filter } = currentTabToolbarConfig || {};

  return (
    <Box>
      {/* Tabs + Toolbar in SAME row */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          backgroundColor: "#fff",
          px: 0.85,
          py: 0.5,
        }}
      >
        {/* LEFT: Tabs */}
        <Tabs
          value={currentTab}
          onChange={onTabChange}
          aria-label="styled tabs"
          variant="scrollable"
          scrollButtons="auto"
          textColor="inherit"
          sx={{
            "& .MuiTabs-indicator": { display: "none" },
            "& .MuiTab-root": {
              border: "1px solid #ddd",
              backgroundColor: "#f2f3f4",
              color: "#000",
              fontWeight: 500,
              fontSize: "0.85rem",
              textTransform: "none",
              minHeight: "40px",
              padding: "8px 16px",
              marginRight: "4px",
              marginBottom: "0px"
            },
            "& .Mui-selected": {
              backgroundColor: "#ffffff",
              borderBottom: "none",
            },
          }}
        >
          {tabs.map((tab, index) => {
            if (tab.label === 'Details' || tab.label === 'Report') { return null; }
            return (
              <Tooltip title={tab.tooltip || ""} key={index}>
                <Tab label={tab.label} />
              </Tooltip>
            )
          })}

        </Tabs>

        {/* RIGHT: Toolbar Controls */}
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          flexWrap="nowrap"
          minHeight={36}
          sx={{ margin: "4px 0 10px 0" }}
        >
          {currentTabData.dropdowns &&
            currentTabData.dropdowns.map((dropdown, index) => (
              <FormControl
                key={index}
                size="small"
                sx={{ minWidth: 150, fontSize: "0.85rem", minHeight: "36px" }}
              >
                <Select
                  value={dropdownValues[index] || ""}
                  onChange={(e) => {
                    handleDropdownChange(index, e.target.value);
                    dropdown.onChange?.(e.target.value);
                  }}
                  displayEmpty
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <Typography sx={{ color: "#9e9e9e" }}>
                          {dropdown.label}
                        </Typography>
                      );
                    }
                    return selected;
                  }}
                >
                  {/* This works as a non-selectable header */}
                  {dropdown.options.map((opt, i) => (
                    <MenuItem key={i} value={opt}>
                      {opt}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ))}

          {currentTabData.toggle && (
            <Box display="flex" alignItems="center">
              <Typography variant="body2" sx={{ mr: 1, fontSize: "0.85rem" }}>
                {currentTabData.toggle.label}
              </Typography>
              <Switch
                checked={currentTabData.toggle.checked}
                onChange={currentTabData.toggle.onChange}
                size="small"
              />
            </Box>
          )}

          {icons &&
            icons.map((icon, idx) => {
              const IconComponent = iconMap[icon.type];
              return (
                <Tooltip
                  key={idx}
                  title={icon.type.charAt(0).toUpperCase() + icon.type.slice(1)}
                >
                  <span>
                    <IconButton
                      onClick={icon.onClick}
                      disabled={icon.disabled}
                      size="small"
                    >
                      <IconComponent fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              );
            })}

          {buttons &&
            buttons.map((btn, idx) => {
              const showTooltip = btn.disabled && btn.tooltip;
              return (
                // <ThemeProvider theme={lowerLayerButtonTheme} key={idx}>
                <>
                  {showTooltip ? (
                    <Tooltip title={btn.tooltip} arrow>
                      <span>
                        <Button
                          sx={{
                            "&.Mui-disabled": {
                              backgroundColor: "#d7d4d4ff",
                              color: "#fff"
                            }
                          }}
                          size="medium"
                          disabled
                          onClick={btn.onClick}
                        >
                          {btn.label}
                        </Button>
                      </span>
                    </Tooltip>
                  ) : (
                    <Button
                      // sx={{
                      //   "&.Mui-disabled": {
                      //     backgroundColor: "#d7d4d4ff",
                      //     color: "#fff"
                      //   }
                      // }}
                      size="small"
                      variant="contained"
                      sx={{
                        color: btn.label === 'Approve' ? '#fff' : '#d32f2f',
                        backgroundColor: btn.label === 'Approve' ? '#2e7d32' : '#fff',
                        border: btn.label === 'Approve' ? '#2e7d32' : btn.disabled ? 
                        '#d32f2f' : '1px solid #d32f2f',
                      }}
                      //size="medium"
                      disabled={btn.disabled}
                      onClick={btn.onClick}
                    >
                      {btn.label}
                    </Button>
                  )}
                </>
                // </ThemeProvider>
              );
            })}
          {search && (
            <TextField
              variant="standard"
              placeholder={search.placeholder || "Search"}
              size="small"
              onChange={(e) => search.onChange?.(e.target.value)}
              sx={{ width: 200, "& .MuiInputBase-input": { fontSize: 13 } }}
            />
          )}

          {filter && (
            <Tooltip title="Filter">
              <IconButton onClick={filter.onClick} size="small">
                <FilterAltOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {/* {currentTabData.timeHorizon && (
            <Tooltip title="Time Horizon">
              <IconButton
                size="small"
                sx={{ mr: 2}}
                onClick={() => setShowSliderPanel((prev) => !prev)}
              >
                <TodayIcon fontSize="medium" />
              </IconButton>
            </Tooltip>
          )} */}
          {startAdornment}
        </Box>
      </Box>

      {/* {showSliderPanel && currentTabData.timeHorizon && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",   // MOVE TO RIGHT
            mr: 2,                         // right spacing
            mb: 2
          }}
        >
          <Box
            sx={{
              width: "300px",
              minHeight: "70px",
              backgroundColor: "#FAFAFA",
              borderRadius: "12px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
              px: 2,
              py: 0.5,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Title
            <Typography
              sx={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#6d6c6cff"
              }}
            >
              Time Horizon
            </Typography>

            {/* Radio buttons */}
      {/* <Box display="flex" alignItems="center" gap={3} sx={{ mb: 0 }}>
              <Box display="flex" alignItems="center">
                <input
                  type="radio"
                  checked={currentTabData.timeHorizon.mode === "weeks"}
                  onChange={() => currentTabData.timeHorizon.onModeChange("weeks")}
                  style={{ transform: "scale(1.3)" }}
                />
                <Typography sx={{ ml: 1, fontSize: "0.9rem" }}>By Weeks</Typography>
              </Box>

              <Box display="flex" alignItems="center">
                <input
                  type="radio"
                  checked={currentTabData.timeHorizon.mode === "dates"}
                  onChange={() => currentTabData.timeHorizon.onModeChange("dates")}
                  style={{ transform: "scale(1.3)" }}
                />
                <Typography sx={{ ml: 1, fontSize: "0.9rem" }}>By Date Range</Typography>
              </Box>
            </Box> */}

      {/* Slider */}
      {/* <Slider
              value={currentTabData.timeHorizon.value}
              onChange={(e, val) => currentTabData.timeHorizon.onChange(val)}
              min={currentTabData.timeHorizon.min}
              max={currentTabData.timeHorizon.max}
              step={1}
              sx={{
                color: "#1976d2",
                "& .MuiSlider-thumb": { width: 18, height: 18 },
                "& .MuiSlider-rail": { height: 4 },
                "& .MuiSlider-track": { height: 4 },
              }}
            />
          </Box>
        </Box>
      )}  */}

      {/* Tab Content */}
      {validTabs.some(label => label === currentTabData.label) ? <Box sx={{ px: 0.85, pt: 0 }}>{currentTabData.component}</Box>
        : <Box sx={{ px: 0.85, pt: 0 }}>{currentTabData.content}</Box>}
    </Box>
  );
};

export default TabLayout;
